import {
  WsEsterno,
  WsEsternoParametroServizio,
  WsEsternoParametroServizioTipo,
  useGetWsEsterni,
} from '@framework/api-client';
import {
  AsyncServiceMethod,
  Datatype,
  IAsyncService,
  IAsyncServiceParameter,
  mapAsyncServiceField,
} from '@framework/engine';

export function useConfigurationAsyncServices() {
  const { data, error, isLoading } = useGetWsEsterni({
    limite: 9000,
    flWidget: true,
  });
  return data?.dati?.map(transformWsEsternoInAsyncService) ?? [];
}

export function useFillableAsyncServices() {
  const { data, error, isLoading } = useGetWsEsterni({
    limite: 9000,
    flWidget: true,
  });
  return data?.dati?.map(transformWsEsternoInAsyncService) ?? [];
}

/**
 * Converte un servizio esterno in un servizio asincrono utilizzabile
 * dall'engine.
 */
export function transformWsEsternoInAsyncService(
  webservice: WsEsterno,
): IAsyncService {
  return {
    id: webservice.id!,
    name: webservice.denominazione,
    url: webservice.url,
    method: webservice.metodo! as AsyncServiceMethod,
    inputs:
      webservice.input?.map(input =>
        transformWsEsternoParametroInAsyncServiceParameter(input),
      ) ?? [],
    outputs:
      webservice.output?.parametri?.map(output =>
        transformWsEsternoParametroInAsyncServiceParameter(output),
      ) ?? [],
    type: webservice.tipoWsEsterno,
    outputRoot: webservice.output?.root,
  };
}

function transformWsEsternoParametroInAsyncServiceParameter(
  parameter: WsEsternoParametroServizio,
): IAsyncServiceParameter {
  return {
    // Nome "flatten" del campo in root
    name: mapAsyncServiceField(parameter.nome),
    // Path originale del campo
    sourcePath: parameter.nome,
    type: parameter.array
      ? {
          type: Datatype.Array,
          itemsType: tipoToDatatype(parameter.tipo),
        }
      : { type: tipoToDatatype(parameter.tipo) },
  };
}

function tipoToDatatype(tipo: WsEsternoParametroServizioTipo) {
  switch (tipo) {
    case WsEsternoParametroServizioTipo.BOOLEAN:
      return Datatype.Boolean;
    case WsEsternoParametroServizioTipo.DATE:
      return Datatype.Date;
    case WsEsternoParametroServizioTipo.NUMBER:
      return Datatype.Number;
    case WsEsternoParametroServizioTipo.STRING:
      return Datatype.String;
    default:
      return Datatype.String;
  }
}
